import { Button } from 'antd';
import { FiChevronDown } from 'react-icons/fi';
import React, { useMemo, useRef, useState } from 'react';
import { CSSTransition } from 'react-transition-group';
import useOutsideClick from 'src/hooks/useOutsideClick';
import PropTypes from 'prop-types';
import * as Styled from './style';
import VisibilityScopeSettings from '../Variation/VisibilityScopeSettings';

export default function Filters({ filters, onChange }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const containerRef = useRef(null);
  const openButtonRef = useRef(null);
  const activeFilterCount = useMemo(() => {
    return Object.values(filters).reduce(
      (acc, filter) => acc + (Array.isArray(filter) ? filter.length : 0),
      0
    );
  }, [filters]);

  useOutsideClick(
    containerRef,
    () => setIsMenuOpen(false),
    true,
    e => {
      const { target } = e;
      if (
        openButtonRef.current &&
        (openButtonRef.current === target || openButtonRef.current.contains(target))
      ) {
        return false;
      }
      return true;
    }
  );

  return (
    <Styled.FilterContainer>
      <Button
        icon={<FiChevronDown />}
        iconPosition="end"
        onClick={() => setIsMenuOpen(!isMenuOpen)}
        ref={openButtonRef}
      >
        Filters {activeFilterCount ? `(${activeFilterCount})` : ''}
      </Button>
      <CSSTransition in={isMenuOpen} timeout={200} unmountOnExit>
        <Styled.FilterMenuContainer ref={containerRef}>
          <VisibilityScopeSettings
            {...filters}
            handleClientsChange={clients => onChange({ ...filters, clients })}
            handleCompanyTypesChange={companyTypes => onChange({ ...filters, companyTypes })}
            handleContactTypesChange={contactTypes => onChange({ ...filters, contactTypes })}
            handleParentCompaniesChange={parentCompanies =>
              onChange({ ...filters, parentCompanies })
            }
            handleTopLevelsChange={topLevels => onChange({ ...filters, topLevels })}
            handleVisibilityScopeChange={visibilityScope =>
              onChange({
                ...filters,
                visibilityScope,
                clients: [],
                companyTypes: [],
                parentCompanies: [],
                topLevels: [],
                contactTypes: []
              })
            }
            showAllClientsOption
            showPlaceholderAsCount
            selectProps={{
              showPlaceholderAsCount: true,
              controlShouldRenderValue: false
            }}
          />
        </Styled.FilterMenuContainer>
      </CSSTransition>
    </Styled.FilterContainer>
  );
}

Filters.propTypes = {
  filters: PropTypes.shape({
    visibilityScope: PropTypes.string,
    companyTypes: PropTypes.arrayOf(PropTypes.object),
    contactTypes: PropTypes.arrayOf(PropTypes.object),
    parentCompanies: PropTypes.arrayOf(PropTypes.object),
    topLevels: PropTypes.arrayOf(PropTypes.object),
    clients: PropTypes.arrayOf(PropTypes.object)
  }).isRequired,
  onChange: PropTypes.func.isRequired
};
